import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation,ViewChild, ElementRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource,MatSelect} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { TechnologyForCreationResponse, SetConfigBoard, GetSpaceDetailsBoardSetup, DeleteConfiguration, GetAlertConfigBoard, GetAlertConfigSpace, saveConfigurationSettings } from '../../technologyoverlay';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { getBuilding, getCampus } from '../../../../api';
import { appsettings } from '../../../../app-settings';
import { RollbarService } from '../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage } from '../../../../app-general';
import {Router} from '@angular/router';
import { Http } from '@angular/http';
import { ApiService } from '../../../../api.service';
import { takeUntil } from 'rxjs/operators';
import { AlertSharedService } from '../../../../_services/index';
import { GeneralMessageComponent } from '../../../../general-message/general-message.component';

@Component({
 
  selector: 'app-edit-config',
  templateUrl: './edit-config.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-config.component.scss']
})
export class EditConfigComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  downIcon = 0;
 
  minheight = "230px";
  location;
  deleteConfigId;
  flag = 0;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  editConfigrowHeight = "79px";
  screenWidth;
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  isundo = 0;
  undooperation = true;
  undopane = 0
  Campusdetails;
  Buildingdetails;
  Spacedetails;
  selectedCampusId = '';
  selectedCampusName;
  //selectedBuildingId = 0;
  buildingId = "";
  selectedBuildingName;
  dataSource;
  dataSourcecnt;
  boardSetupData = [];
  configuredSetupData = [];
  displayedColumns: string[]= ["Point","Device","PointName","SpaceName","Index"];
  //displayedColumns: string[]= ["SpaceName","Index"];
  public configeditForm : FormGroup;
  selectedSpaceId;
  selectedBoardName = "";
  existingData = [];
  boardlength = 0;
  boardId;
  @ViewChild('selBuilding') selBuilding: MatSelect;

  constructor(public http: Http,private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditConfigComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
          private technologyoverlayService: TechnologyoverlayService,private alertSharedService: AlertSharedService,
          public dialog: MatDialog,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService) 
  {
    try
      {

          this.selectedBoardName = data.BoardName;          
          this.buildingId = data.BuildingId;
          this.boardlength = data.setupDataRowCount;
          this.selectedBuildingName = data.Building;
          this.selectedCampusName = data.Campus;
          this.boardId = data.BoardId;
          
          if(data.CampusId == 0)
            this.selectedCampusId = '';
          else
            this.selectedCampusId = data.CampusId;
          
          this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
            
          if (change) {        
                if (change.mqAlias == 'xs') {
                  this.columns = 2;  
                  this.firstcolumns = 1;      
                  this.minheight = "auto";            
                } 
                else if (change.mqAlias == 'sm') {
                  this.columns = 2;
                  this.firstcolumns = 2;  
                  this.minheight = "auto";         
                }  
                else if (change.mqAlias == 'md') {
                  this.columns = 2;  
                  this.firstcolumns = 1;  
                  this.minheight = "230px";      
                }               
                else
                {
                  this.columns = 4;  
                  this.firstcolumns = 2;    
                  this.minheight = "230px";          
                }
            }
          });

      }
      catch(err)
      {
        throw new Error('edit-config.component.ts' + ' - constructor() - ' + err.message);
      }
  }

  ngOnInit() 
  {  
    try
    {
       this.configeditForm = new FormGroup({   
            filename:new FormControl(''),                     
            boardname:new FormControl(''),
            ipaddress:new FormControl(''),                                 
            udpport:new FormControl(''),
            campus: new FormControl('',[Validators.required]),          
            building: new FormControl('',[Validators.required]), 
            description: new FormControl('',[Validators.required, Validators.pattern(appsettings.Name_Pattern)]),
            hdnFileName: new FormControl(''),
            hdnBoardName: new FormControl(''),
            hdnIpAddress: new FormControl(''),
            hdnUdpPort: new FormControl(''),
        });

        for (let i = 1; i <= this.boardlength; i++) 
        {
          this.configeditForm.controls['mat_select_' + i] =  new FormControl('');
        }

        this.configeditForm.get('filename').disable();
        this.configeditForm.get('boardname').disable();
        this.configeditForm.get('ipaddress').disable();
        this.configeditForm.get('udpport').disable();
        this.getCampusDetails();
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - ngOnInit() - ' + err.message);
    }
  }

  handleInput(event) 
  { 
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.configeditForm.controls).forEach(field => { // {1}
        const control = this.configeditForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('edit-config.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  getCampusDetails()
  {
    try
      {
        let campusid: getCampus = {
          siteId : this.SiteId,
          authKey: localStorage.getItem("Authkey")
        }
        this.apiService.getCampusDetails(campusid).pipe(takeUntil(this._onDestroy))
        .subscribe((CampusDetails : any[])=>{  
          this.Campusdetails = CampusDetails["apiReturn"];
        });  
      }
      catch (err) {
        throw new Error('edit-config.component.ts' + ' - getCampusDetails() - ' + err.message);
      }
  }

  getSpaceDetailsWithBoardSetupData(selCampusId,selBuildId)
  {
    try
    {
      let getSpaceInfo: GetSpaceDetailsBoardSetup = {
          siteId : this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          campusId:parseInt(selCampusId),
          buildId:parseInt(selBuildId),
          boardName:this.selectedBoardName
        }
        this.technologyoverlayService.getSpaceDetailsWithBoardSetupData(getSpaceInfo).pipe(takeUntil(this._onDestroy))
        .subscribe((SpaceDetails: any[])=>{
          this.boardSetupData = SpaceDetails;
          this.dataSource = new MatTableDataSource( SpaceDetails);
          this.dataSource.data =  SpaceDetails;
          this.dataSourcecnt =  SpaceDetails.length;

          SpaceDetails.forEach(element => {
          this.configeditForm.get("mat_select_" + element.Index).setValue(element.SpaceName);
          });

        });
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - getSpaceDetailsWithBoardSetupData() - ' + err.message);
    }
  }

  callgetSpacedetails(buildId)
  {
    this.getSpaceDetailsWithBoardSetupData(this.selectedCampusId,this.buildingId);
    let obj = this.Buildingdetails.find(o => o.BuildId === buildId);
    if(obj)
    {
      this.buildingId = obj.BuildId;
      this.selectedBuildingName = obj.BuildingName;
    }
  }

  changecampus(campusid,campusName)
  {
    this.selectedCampusId = campusid;
    this.selectedCampusName = campusName;
    this.buildingId = "";
  }

  changebuilding(buildingid,buildingName)
  {
    this.buildingId = buildingid;
    this.selectedBuildingName = buildingName;
  }

  setboardsetupdetails(spaceId,setupData)
  {
    try
    {
      var filteredRow =  this.boardSetupData.filter(x => x.Index == setupData["Index"]);

      let checkAlertBySpaceId : GetAlertConfigSpace = {
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        boardId: parseInt(this.boardId),
        spaceId: filteredRow[0].SpaceName.toString()
      }

      this.technologyoverlayService.getAlertForConfiguredSpace(checkAlertBySpaceId).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse : TechnologyForCreationResponse[])=>{         
          if(apiresponse.toString() == "yes")
          {
            generateAlertMessage(this.dialog, 'Selected Space has open alerts, please complete or cancel those alerts and try again.');
            this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(filteredRow[0].SpaceName);
            return;
          }
          else
          {
            var checkRelay = this.boardSetupData.find(o => o.SpaceName === spaceId);
            if(checkRelay)
            {
              if(checkRelay.Point == setupData["Point"])
              {
                var item =  this.boardSetupData.find(x => x.Index == setupData["Index"]);
                if(item){
                  item.SpaceName = spaceId;
                }
              }
              else
              {
                var spaceRecords =  this.boardSetupData.filter(x => x.Index == setupData["Index"]);
                
                generateAlertMessage(this.dialog, 'Selected Space already assigned for point '+ checkRelay.Point);
                if(spaceRecords.length > 0)
                {
                  this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(spaceRecords[0].SpaceName);
                }
                else
                {
                  this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(0);
                }
                return;
              }
            }
            else
            {
              var pointList = [];
              var setupPointList = this.boardSetupData.filter(o => o.SpaceName != '' && o.Point == setupData["Point"]);
              if(setupPointList.length > 0)
              {
                 for(var i = 0; i < setupPointList.length; i++)
                 {
                    if(setupPointList[i].Spaces.some(item => item.SpaceId === setupPointList[i].SpaceName))
                    {
                      pointList.push(setupPointList[i]);
                    }
                 }
                 //alert(pointList);
                 if(pointList.length == 0)
                 {
                    var item =  this.boardSetupData.find(x => x.Index == setupData["Index"]);
                    if(item)
                    {
                      item.SpaceName = spaceId;
                    }
                 }
                 else
                 {
                    if(pointList.length == 1)
                    {
                      if(pointList[0].Index == setupData["Index"])
                      {
                        var item =  this.boardSetupData.find(x => x.Index == setupData["Index"]);
                        if(item)
                        {
                          item.SpaceName = spaceId;
                        }
                      }
                      else
                      {
                        if(pointList[0].SpaceName != spaceId)
                        {
                          var spaceRecords =  this.boardSetupData.filter(x => x.Index == setupData["Index"]);
                          if(spaceRecords.length > 0)
                          {
                            if(spaceRecords[0].SpaceName > 0)
                            {
                              generateAlertMessage(this.dialog, 'Not able to select the different space for same relay');
                              this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(spaceRecords[0].SpaceName);
                              return;
                            }
                            else
                            {
                              generateAlertMessage(this.dialog, 'Not able to select the different space for same relay');
                              this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(0);
                              return;
                            }
                          }
                        }
                        else
                        {
                          var item =  this.boardSetupData.find(x => x.Index == setupData["Index"]);
                          if(item)
                          {
                            item.SpaceName = spaceId;
                          }
                        }
                      }
                    }
                    else
                    {
                      if(pointList[0].SpaceName != spaceId)
                      {
                        var spaceRecords =  this.boardSetupData.filter(x => x.Index == setupData["Index"]);
                        if(spaceRecords.length > 0)
                        {
                          if(spaceRecords[0].SpaceName > 0)
                          {
                            generateAlertMessage(this.dialog, 'Not able to select the different space for same relay');
                            this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(spaceRecords[0].SpaceName);
                            return;
                          }
                          else
                          {
                            generateAlertMessage(this.dialog, 'Not able to select the different space for same relay');
                            this.configeditForm.get("mat_select_" + setupData["Index"]).setValue(0);
                            return;
                          }
                        }
                      }
                      else
                      {
                         var item =  this.boardSetupData.find(x => x.Index == setupData["Index"]);
                          if(item)
                          {
                            item.SpaceName = spaceId;
                          }
                      }
                    }
                  }
              }
              else
              {
                var item =  this.boardSetupData.find(x => x.Index == setupData["Index"]);
                if(item)
                {
                  item.SpaceName = spaceId;
                }
              }
            }
          }
        });
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - setboardsetupdetails() - ' + err.message);
    }
  }

  public onCloseCancel = () => 
  {   
    try
    {
      if(!SessionCheck(this.router))
      {
          return;
      }
      this.thisDialogRef.close('Cancel');
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - onCloseCancel() - ' + err.message);
    }
  }

  public hasError = (controlName: string, errorName: string) =>
  {
    try
    {
      return this.configeditForm.controls[controlName].hasError(errorName);
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - hasError() - ' + err.message);
    }
  }

  public oneditConfigdetails = (ConfigFormValue) => 
  {  
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      
      if (this.configeditForm.valid) {
         this.saveConfigurationSettings(ConfigFormValue);
      }
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - oneditConfigdetails() - ' + err.message);
    }
  }

  private saveConfigurationSettings = (ConfigFormValue) => 
  {
    try
    {
      (document.activeElement as HTMLTextAreaElement).blur();
       if (this.configeditForm.valid) 
       {
          let saveclick = document.getElementById('btnsaveclick');
          saveclick.className = 'clsconfigeditbutton mat-raised-button disablebtn'; 
          let SaveConfig : saveConfigurationSettings = {
              siteId: this.SiteId,
              authKey: localStorage.getItem("Authkey"),
              fileName: ConfigFormValue.hdnFileName,
              boardName:ConfigFormValue.hdnBoardName,
              ipAddress:ConfigFormValue.hdnIpAddress,
              udpPort:ConfigFormValue.hdnUdpPort,
              campusId:parseInt(this.selectedCampusId),
              campusName:this.selectedCampusName,
              buildingId:parseInt(this.buildingId),
              buildingName:this.selectedBuildingName,
              description:ConfigFormValue.description
            }
            this.technologyoverlayService.saveConfigurationSettings(SaveConfig).pipe(takeUntil(this._onDestroy))
            .subscribe((configSettingsId : any[])=>{                 
              var _arrSaveBoardSetupDetails = [];

              for(var i=0;i<this.boardSetupData.length;i++)
              {
                var _SaveBoardSetupDetails = {};

                _SaveBoardSetupDetails['Point'] = this.boardSetupData[i].Point;
                _SaveBoardSetupDetails['Device'] = this.boardSetupData[i].Device;
                _SaveBoardSetupDetails['PointName'] = this.boardSetupData[i].PointName;
                _SaveBoardSetupDetails['SpaceName'] = this.boardSetupData[i].SpaceName;

                _arrSaveBoardSetupDetails.push(_SaveBoardSetupDetails);
              }

              let SaveboardSettings : SetConfigBoard= {
                siteId: this.SiteId,
                authKey: localStorage.getItem("Authkey"),
                jsonData:JSON.stringify(_arrSaveBoardSetupDetails),
                configrationSettingsId:configSettingsId
              }

              this.technologyoverlayService.saveConfigurationBoard(SaveboardSettings).pipe(takeUntil(this._onDestroy))
              .subscribe((apiresponse : any[])=>{
                console.log(apiresponse)
                if(apiresponse.toString() == "true")
                { 	      
                  generateAlertMessage(this.dialog, 'Board Configured Successfully.')
                  this.thisDialogRef.close();
                }  
              });
            });
         }
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - saveConfigurationSettings() - ' + err.message);
    }
 }
 
  opendeleteconfigdialog() 
  { 
    try
    {
      var GeneralMessageData = {
        General_header: "Delete Board",                
        GeneralMessage: "Are you sure you would like to delete this Board?",
        General_first: "Yes",
        General_second: "No"
      }   

      let dialogRef = this.dialog.open(GeneralMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: GeneralMessageData
      }); 

      dialogRef.afterClosed().subscribe(result => {     
        if(result == "First")
        {                     
          this.deleteConfigurationSettings(this.selectedBoardName)               
        }
        else
        {                
          dialogRef.close('Cancel');          
          return;
        }            
      });        
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - opendeletedialog() - ' + err.message);
    }
  }

  selectbuilding(CampusId)
  {   
    try
    {  
      var select_Buildid;
      var check_BuildId;      
      select_Buildid = this.buildingId;
      
      if(CampusId > 0)
      {
        let buildingid: getBuilding = {
          siteId : this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          campusId :  CampusId
        }
      
        this.apiService.getBuildingDetails(buildingid).pipe(takeUntil(this._onDestroy))
        .subscribe((BuildingDetails : any[])=>{ 
          this.Buildingdetails = BuildingDetails["apiReturn"];
          if(this.Buildingdetails.length == 0)  
          {         
            this.buildingId = "";
          }
          this.Buildingdetails.forEach(function (data) {
            if(data.BuildId == select_Buildid)
            {
              check_BuildId = data.BuildId;
              return false;
            }
            else{
              return true;
            }
          }); 
          this.buildingId = check_BuildId; 
          if(this.buildingId == undefined)
            this.buildingId = "";                                     
          let obj = this.Campusdetails.find(o => o.CampusId === CampusId);
          if(obj)
          {
            this.selectedCampusId = obj.CampusId;
            this.selectedCampusName = obj.CampusName;
          }
        });  
      }
    }
    catch (err) {
      throw new Error('edit-resident.component.ts' + ' - selectbuilding() - ' + err.message);
    }
  }
 
deleteConfigurationSettings(boardName)
 {
    try
    {
      let checkAlertByBoardId : GetAlertConfigBoard = {
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        boardId: this.boardId
      }
      this.technologyoverlayService.getAlertForConfiguredBoard(checkAlertByBoardId).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse : TechnologyForCreationResponse[])=>{         
          if(apiresponse.toString() == "yes")
          {
            generateAlertMessage(this.dialog, 'Board has open alerts, please complete or cancel those alerts and try again.');
          }
          else
          {
            let deleteConfigByBoardName : DeleteConfiguration = {
              siteId: this.SiteId,
              authKey: localStorage.getItem("Authkey"),
              boardName: boardName
            }
          
            this.technologyoverlayService.deleteConfigurationSettings(deleteConfigByBoardName).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : TechnologyForCreationResponse[])=>{         
            if(apiresponse.toString() == "true")
            { 	      
              generateAlertMessage(this.dialog, 'Board Configuration deleted successfully.')
            }    
            else if(apiresponse.toString() == "false")
            {          
              generateAlertMessage(this.dialog, 'Board Configuration deleted failed.')
            }
            this.thisDialogRef.close();  
            });
          }
      });
    }    
    catch(err)
    {
        throw new Error('edit-config.component.ts' + ' - deleteConfigurationSettings() - ' + err.message);
    }   
  } 
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
